import React, {Fragment, useState} from 'react'
import {TextField, Typography} from '@mui/material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import './index.scss'

interface FormikTextBoxProps {
    id: string
    placeholder?: string
    formik: any
    onChange?(...args: unknown[]): unknown
    className?: string
    maxLength?: number
    fullWidth?: boolean
    subtitle?: boolean
    disabled?: boolean
}

const FormikTextBox = ({
    id,
    formik,
    className,
    onChange,
    placeholder,
    maxLength,
    fullWidth,
    subtitle,
    disabled
}: FormikTextBoxProps) => {
    const [length, setLength] = useState<number>(0)

    const handleInputChange = (e) => {
        const inputValue = e.target.value
        formik.setFieldValue(id, inputValue)
        setLength(inputValue.length)
        if (onChange) {
            onChange(e)
        }
    }

    const getError = (
        <>
            <ErrorOutlineOutlinedIcon className='formik-error__info-icon' />
            {formik.errors[id]}
        </>
    )

    return (
        <Fragment>
            <TextField
                id={id}
                name={id}
                placeholder={placeholder}
                value={formik.values[id]}
                onChange={handleInputChange}
                onBlur={() => formik.setFieldTouched(id)}
                error={formik.touched[id] && Boolean(formik.errors[id])}
                helperText={formik.touched[id] && !!formik.errors[id] && getError}
                InputProps={{
                    inputProps: {
                        maxLength
                    }
                }}
                className={`formik-textbox ${className}`}
                fullWidth={fullWidth}
                multiline
                rows={4}
                disabled={disabled}
                autoComplete='on'
            />
            {!subtitle && !(formik.touched[id] && Boolean(formik.errors[id])) && (
                <Typography variant='subtitle1' className='counter-string'>
                    {length} of 1,000 characters
                </Typography>
            )}
        </Fragment>
    )
}

FormikTextBox.defaultProps = {
    maxLength: 1000,
    fullWidth: false,
    subtitle: false,
    disabled: false
}

export default FormikTextBox
